import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import shirts from "../assets/shirt.jpg";
import pants from "../assets/pant.png";
import blouse from "../assets/blouse.png";
import kurta from "../assets/kurthis.png";

export default function FitDetails() {
  const { dressName } = useParams();
  const [fits, setFits] = useState([]);
  const [selectedFit, setSelectedFit] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const images = { Shirt: shirts, Pant: pants, Blouse: blouse, Kurta: kurta };

  useEffect(() => {
    fetch("https://athf.beezetsoftwaresolution.com/getFittings.php/")
      .then((res) => res.json())
      .then((json) => {
        
        const filtered = json.data.filter((f) => f.dress_type === dressName);
        setFits(filtered);
      });
  }, [dressName]);

  return (
    <div className="p-0 max-w-md mx-auto font-[Inter] relative min-h-screen bg-white">

      
      <div className="bg-blue-600 text-white py-4 text-center font-semibold text-lg relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-xl font-bold text-white"
        >
          ←
        </button>
        {dressName} Fit Options
      </div>

     
      {!selectedFit &&
        fits.map((fit) => (
          <div
            key={fit.id}
            onClick={() => setSelectedFit(fit)}
            className="p-4 border rounded-lg m-4 cursor-pointer hover:bg-gray-100 text-center"
          >
            {fit.notes}
          </div>
        ))}

      
      {selectedFit && (
        <div className="mt-4 p-4">

          <h3 className="text-xl font-semibold text-center mb-2">
            {selectedFit.notes}
          </h3>

          
          <div className="relative w-full flex justify-center mt-4">
            <img
              src={images[selectedFit.dress_type]}
              className="w-[100%] max-w-[600px]"
              alt="dress"
            />

            {selectedFit.dress_type === "Shirt" && (
              <>
                {selectedFit.shoulder_cm && (
                  <span className="absolute top-[8%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Shoulder: {selectedFit.shoulder_cm} cm
                  </span>
                )}

                {selectedFit.neck_cm && (
                  <span className="absolute top-[14%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Neck: {selectedFit.neck_cm} cm
                  </span>
                )}

                {selectedFit.breadth_cm && (
                  <span className="absolute top-[45%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Chest: {selectedFit.breadth_cm} cm
                  </span>
                )}

                {selectedFit.height_cm && (
                  <span className="absolute top-[45%] right-[1%] text-red-600 text-sm font-semibold rotate-90">
                    Height: {selectedFit.height_cm} cm
                  </span>
                )}

                {selectedFit.hand_size_cm && (
                  <span className="absolute top-[25%] left-[4%] text-red-600 text-sm font-semibold rotate-[-56deg]">
                    Sleeve: {selectedFit.hand_size_cm} cm
                  </span>
                )}

                {selectedFit.waist_cm && (
                  <span className="absolute bottom-[14%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Waist: {selectedFit.waist_cm} cm
                  </span>
                )}
              </>
            )}

            
            {selectedFit.dress_type === "Pant" && (
              <>
                {selectedFit.waist_cm && (
                  <span className="absolute top-[8%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Waist: {selectedFit.waist_cm} cm
                  </span>
                )}

                {selectedFit.hip_cm && (
                  <span className="absolute top-[22%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Hip: {selectedFit.hip_cm} cm
                  </span>
                )}

                {selectedFit.height_cm && (
                  <span className="absolute top-[50%] right-[1%] text-red-600 text-sm font-semibold rotate-90">
                    Length: {selectedFit.height_cm} cm
                  </span>
                )}

                {selectedFit.thigh_cm && (
                  <span className="absolute top-[35%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Thigh: {selectedFit.thigh_cm} cm
                  </span>
                )}

                {selectedFit.knee_cm && (
                  <span className="absolute top-[55%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Knee: {selectedFit.knee_cm} cm
                  </span>
                )}

                {selectedFit.bottom_cm && (
                  <span className="absolute bottom-[10%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Bottom: {selectedFit.bottom_cm} cm
                  </span>
                )}

                {selectedFit.inseam_cm && (
                  <span className="absolute top-[60%] left-[10%] text-red-600 text-sm font-semibold">
                    Inseam: {selectedFit.inseam_cm} cm
                  </span>
                )}
              </>
            )}

          
            {selectedFit.dress_type === "Kurta" && (
              <>
                {selectedFit.shoulder_cm && (
                  <span className="absolute top-[10%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Shoulder: {selectedFit.shoulder_cm} cm
                  </span>
                )}

                {selectedFit.neck_cm && (
                  <span className="absolute top-[6%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Neck: {selectedFit.neck_cm} cm
                  </span>
                )}

                {selectedFit.breadth_cm && (
                  <span className="absolute top-[25%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Bust: {selectedFit.breadth_cm} cm
                  </span>
                )}

                {selectedFit.waist_cm && (
                  <span className="absolute top-[42%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Waist: {selectedFit.waist_cm} cm
                  </span>
                )}

                {selectedFit.hip_cm && (
                  <span className="absolute top-[58%] left-1/2 -translate-x-1/2 text-red-600 text-sm font-semibold">
                    Hip: {selectedFit.hip_cm} cm
                  </span>
                )}

                {selectedFit.height_cm && (
                  <span className="absolute top-[50%] right-[1%] text-red-600 text-sm font-semibold rotate-90">
                    Length: {selectedFit.height_cm} cm
                  </span>
                )}

                {selectedFit.hand_size_cm && (
                  <span className="absolute top-[20%] left-[4%] text-red-600 text-sm font-semibold rotate-[-45deg]">
                    Sleeve: {selectedFit.hand_size_cm} cm
                  </span>
                )}

                {selectedFit.arm_hole_cm && (
                  <span className="absolute top-[15%] left-[15%] text-red-600 text-sm font-semibold">
                    Armhole: {selectedFit.arm_hole_cm} cm
                  </span>
                )}
              </>
            )}
          </div>

         
          <div className="fixed bottom-7 left-1/2 -translate-x-1/2 z-50">
            <button
              onClick={() => setShowPopup(true)}
              className={`${showPopup ? "bg-gray-400" : "bg-blue-600"} text-white px-6 py-3 rounded-full shadow-lg transition-all`}
            >
              Show Measurements
            </button>
          </div>
        </div>
      )}

      
      {showPopup && selectedFit && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-end">
          <div className="bg-white w-full max-w-md p-5 rounded-t-2xl shadow-lg mb-10">
            <h3 className="text-lg font-bold text-center mb-3">Measurements</h3>

            {Object.entries(selectedFit).map(
              ([key, val]) =>
                val &&
                !["id", "dress_type", "notes", "created_at"].includes(key) && (
                  <div key={key} className="flex justify-between border-b py-1 text-sm">
                    <span className="capitalize">{key.replace("_cm", "").replace("_", " ")}</span>
                    <span className="font-semibold">{val} cm</span>
                  </div>
                )
            )}

            <button
              onClick={() => setShowPopup(false)}
              className="mt-4 w-full bg-red-500 text-white py-2 rounded-lg"
            >
              Close
            </button>

          </div>
        </div>
      )}

    </div>
  );
}